/* Mobile menu draft (Oct 30): compact sticky header + bottom-sheet menu. <=768px only. No dependencies. */
(function () {
  'use strict';
  var mq = window.matchMedia('(max-width: 768px)');
  var state = { open: false, lastY: 0, hidden: false, ticking: false, lockY: 0, ignoreScroll: false, lastFocus: null };
  var header, spacer, drawer, panel, ann;

  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function init() {
    // Theme editor re-renders the header section: drop stale moved copies first.
    qa('[data-mm-moved]').forEach(function (el) {
      var fresh = qa('#' + el.id).filter(function (x) { return x !== el; });
      if (fresh.length) el.parentNode.removeChild(el);
    });
    header = q('#MmHeader:not([data-mm-moved])') || q('#MmHeader');
    drawer = q('#MmDrawer:not([data-mm-moved])') || q('#MmDrawer');
    spacer = q('.mm-spacer');
    if (!header || !drawer || header.getAttribute('data-mm-ready')) return;
    header.setAttribute('data-mm-ready', '1');
    panel = q('.mm-drawer__panel', drawer);
    ann = q('.announcement');

    // Move out of #PageContainer (it animates with transitions, which would break position:fixed).
    var pc = document.getElementById('PageContainer');
    if (pc && pc.parentNode) {
      pc.parentNode.insertBefore(header, pc);
      header.setAttribute('data-mm-moved', '');
    }
    document.body.appendChild(drawer);
    drawer.setAttribute('data-mm-moved', '');

    header.classList.add('mm-js');
    if (spacer) spacer.classList.add('mm-js');

    qa('[data-mm-open]', header).forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); openDrawer(b); });
    });
    qa('[data-mm-close]', drawer).forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); closeDrawer(); });
    });
    qa('[data-mm-acc]', drawer).forEach(function (b) {
      b.addEventListener('click', function () {
        var region = document.getElementById(b.getAttribute('aria-controls'));
        var expand = b.getAttribute('aria-expanded') !== 'true';
        b.setAttribute('aria-expanded', expand ? 'true' : 'false');
        if (region) region.hidden = !expand;
      });
    });
    header.addEventListener('focusin', function () { if (state.hidden) { state.hidden = false; paint(); } });
    state.lastY = window.pageYOffset || 0;
    paint();
  }

  /* ---------- Sticky header: hide on scroll down, show on scroll up ---------- */
  function annBottom() {
    if (!ann || !ann.offsetParent) return 0;
    var b = ann.getBoundingClientRect().bottom;
    return b > 0 ? b : 0;
  }
  function paint() {
    if (!header) return;
    var top = annBottom();
    var y = window.pageYOffset || 0;
    header.style.transform = state.hidden ? 'translate3d(0,-110%,0)' : 'translate3d(0,' + top + 'px,0)';
    header.classList.toggle('is-hidden', state.hidden);
    header.classList.toggle('is-scrolled', y > 2 && !state.hidden);
  }
  function onScroll() {
    if (state.ticking) return;
    state.ticking = true;
    window.requestAnimationFrame(function () {
      state.ticking = false;
      if (!header || !mq.matches) return;
      var y = Math.max(0, window.pageYOffset || 0);
      if (state.ignoreScroll || state.open) { state.lastY = y; state.ignoreScroll = false; paint(); return; }
      var dy = y - state.lastY;
      var headerH = header.offsetHeight || 52;
      if (y <= annBottom() + headerH + 60) { state.hidden = false; state.lastY = y; }
      else if (dy > 8) { state.hidden = !header.contains(document.activeElement); state.lastY = y; }
      else if (dy < -8) { state.hidden = false; state.lastY = y; }
      paint();
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });

  /* ---------- Drawer ---------- */
  function setExpanded(v) {
    qa('[data-mm-open], .js-toggle-slide-nav').forEach(function (b) { b.setAttribute('aria-expanded', v ? 'true' : 'false'); });
  }
  function lockScroll() {
    state.lockY = window.pageYOffset || 0;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = -state.lockY + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
    document.documentElement.classList.add('mm-lock');
  }
  function unlockScroll() {
    var b = document.body;
    b.style.position = ''; b.style.top = ''; b.style.left = ''; b.style.right = ''; b.style.width = '';
    document.documentElement.classList.remove('mm-lock');
    state.ignoreScroll = true;
    window.scrollTo(0, state.lockY);
  }
  function focusables() {
    return qa('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', panel)
      .filter(function (el) { return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement; });
  }
  function onKey(e) {
    if (!state.open) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) { e.preventDefault(); panel.focus(); return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function openDrawer(trigger) {
    if (state.open || !drawer) return;
    state.open = true;
    state.lastFocus = trigger || document.activeElement;
    drawer.hidden = false;
    lockScroll();
    setExpanded(true);
    void drawer.offsetWidth; // let the hidden->shown change paint before animating
    drawer.classList.add('is-open');
    var c = q('.mm-drawer__close', drawer);
    (c || panel).focus({ preventScroll: true });
    document.addEventListener('keydown', onKey, true);
  }
  function closeDrawer(skipFocus) {
    if (!state.open) return;
    state.open = false;
    drawer.classList.remove('is-open');
    setExpanded(false);
    document.removeEventListener('keydown', onKey, true);
    unlockScroll();
    var done = false;
    function hide() { if (done || state.open) return; done = true; drawer.hidden = true; }
    panel.addEventListener('transitionend', hide, { once: true });
    setTimeout(hide, 400);
    if (!skipFocus && state.lastFocus && state.lastFocus.focus) {
      try { state.lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  // Any stock Streamline menu toggle (e.g. the hamburger inside the sticky cart bar) opens the new menu on mobile.
  document.addEventListener('click', function (e) {
    if (!mq.matches || !drawer) return;
    var t = e.target && e.target.closest ? e.target.closest('.js-toggle-slide-nav') : null;
    if (!t || drawer.contains(t)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openDrawer(t);
  }, true);

  var onMq = function () { if (!mq.matches) closeDrawer(true); onScroll(); };
  if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
  window.addEventListener('pageshow', function (e) { if (e.persisted) closeDrawer(true); });
  document.addEventListener('shopify:section:load', function () { header = null; init(); });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
